import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useHomepageSections } from '@/hooks/useSiteData';
import { ScrollAnimation } from '@/hooks/useScrollAnimation';
import giftCard640 from '@/assets/gift-card-640.webp';
import giftCard1280 from '@/assets/gift-card-1280.webp';
import giftCard1920 from '@/assets/gift-card-1920.webp';

export function GiftCardSection() {
  const { data: sections } = useHomepageSections();
  const giftSection = sections?.find(s => s.section_key === 'gift_card');

  if (!giftSection?.is_visible) return null;

  return (
    <section className="py-20 px-4 bg-card relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary/10 rounded-full blur-3xl opacity-50" />
      
      <div className="container mx-auto max-w-4xl relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-12">
          {/* Image */}
          <ScrollAnimation animation="fade-left" className="w-full md:w-1/3 flex justify-center">
            <div className="relative">
              <img 
                src={giftSection.image_url || giftCard1280}
                srcSet={giftSection.image_url ? undefined : `${giftCard640} 640w, ${giftCard1280} 1280w, ${giftCard1920} 1920w`}
                sizes={giftSection.image_url ? undefined : '(max-width: 768px) 50vw, 160px'}
                width={160}
                height={160}
                loading="lazy"
                decoding="async"
                alt="Gift Card" 
                className="h-40 w-auto object-contain transition-all duration-500 hover:scale-110 hover:rotate-6 drop-shadow-lg float"
              />
              {/* Glow behind */}
              <div className="absolute inset-0 bg-primary/30 blur-2xl rounded-full opacity-0 hover:opacity-100 transition-opacity duration-500 -z-10" />
            </div>
          </ScrollAnimation>

          {/* Content */}
          <ScrollAnimation animation="fade-right" delay={200} className="w-full md:w-2/3 text-center md:text-left space-y-4">
            <h2 className="text-3xl font-bold text-gradient-coral">
              {giftSection.title || 'Acquista una Gift Card'}
            </h2>
            <p className="text-lg font-medium text-foreground">
              {giftSection.subtitle || 'Il regalo perfetto per ogni occasione!'}
            </p>
            <p className="text-muted-foreground">
              {giftSection.content || 'Se non sai decidere il regalo ideale o semplicemente vuoi regalare la libertà di scegliere, la Gift Card è il pensiero perfetto!'}
            </p>
            <div className="pt-2">
              <Button 
                asChild 
                className="bg-gradient-coral magnetic-hover glow-pulse"
              >
                <Link to={giftSection.cta_url || '/gift-card'}>
                  {giftSection.cta_text || 'Acquista Ora'}
                </Link>
              </Button>
            </div>
          </ScrollAnimation>
        </div>
      </div>
    </section>
  );
}
